import * as React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

const SvgI24Today = props => {
  return (
    <SvgIcon {...props}>
      <path d="M20 3H19V1H17V3H7V1H5V3H4C2.9 3 2 3.9 2 5V21C2 22.1 2.9 23 4 23H20C21.1 23 22 22.1 22 21V5C22 3.9 21.1 3 20 3ZM20 21H4V8H20V21Z" />
    </SvgIcon>
  );
};

export default SvgI24Today;
